// Date helpers. All dates as YYYY-MM-DD strings in user's local timezone.

export const toISODate = (d) => {
  const dt = d instanceof Date ? d : new Date(d);
  const y = dt.getFullYear();
  const m = String(dt.getMonth() + 1).padStart(2, '0');
  const day = String(dt.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};

export const todayISO = () => toISODate(new Date());

export const addDays = (date, n) => {
  const d = date instanceof Date ? new Date(date) : new Date(date);
  d.setDate(d.getDate() + n);
  return d;
};

export const daysBetween = (a, b) => {
  const ms = new Date(b).setHours(0, 0, 0, 0) - new Date(a).setHours(0, 0, 0, 0);
  return Math.round(ms / (1000 * 60 * 60 * 24));
};

export const weekdayOf = (date) => new Date(date).getDay(); // 0=Sun..6=Sat

export const isScheduledOn = (habit, date) => {
  const wd = weekdayOf(date);
  switch (habit.schedule_type) {
    case 'daily': return true;
    case 'weekdays': return wd >= 1 && wd <= 5;
    case 'weekends': return wd === 0 || wd === 6;
    case 'custom': return (habit.schedule_days || []).includes(wd);
    case 'x_per_week': return true; // always show; counted differently
    default: return true;
  }
};

export const fmtPretty = (d) => {
  const dt = d instanceof Date ? d : new Date(d);
  return dt.toLocaleDateString(undefined, { weekday: 'long', month: 'long', day: 'numeric' });
};

export const monthLabels = () =>
  ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const dayShortLabels = () => ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
